import { z } from "zod"

export const CENTRA_LANGUAGE_CODE = {
    De: "de",
    En: "en",
    Fr: "fr",
    Ja: "ja"
} as const

export type CentraLanguageCode =
    (typeof CENTRA_LANGUAGE_CODE)[keyof typeof CENTRA_LANGUAGE_CODE]

export const LanguageCodeSchema = z.enum(
    Object.values(CENTRA_LANGUAGE_CODE) as [CentraLanguageCode, ...CentraLanguageCode[]]
)

export const validateLanguageCode = (code: string) => {
    return LanguageCodeSchema.safeParse(code)
}

export interface LanguageOption {
    value: CentraLanguageCode
    label: string
    path?: string
}

export const getLanguageLabel = (code: CentraLanguageCode): string => {
    const labels: Record<CentraLanguageCode, string> = {
        [CENTRA_LANGUAGE_CODE.De]: "German",
        [CENTRA_LANGUAGE_CODE.En]: "English",
        [CENTRA_LANGUAGE_CODE.Fr]: "French",
        [CENTRA_LANGUAGE_CODE.Ja]: "Japanese"
    }
    return labels[code]
}

export const languages: LanguageOption[] = Object.values(CENTRA_LANGUAGE_CODE).map(
    code => ({
        value: code,
        label: getLanguageLabel(code)
    })
)

export interface RadioButtonProps {
    options: LanguageOption[]
    name?: string
}
